var kotemplates = require("../../template/kotemplates");
var ssoCallback = require("../callback/sso");
var loginCallback = require("../callback/login");

module.exports = {
  login: {
    url: "#/login",
    callback: loginCallback,
    initRoute: kotemplates.registerLogin,
    page: require("../../component/login/loginIndex.html"),
  },
  kfLogin:{
    url: "#/kfLogin",
    callback: loginCallback,
    initRoute: kotemplates.registerKFLogin,
    page: require("../../component/login/kingfa/KingFaLogin.html"),
  },
  sso: {
    url: "#/sso",
    callback: ssoCallback,
    initRoute: kotemplates.registerSSO,
    page: require("../../component/sso/ssoIndex.html"),
  },
  ssoLogin: {
    url: "#/ssoLogin",
    initRoute: kotemplates.registerSSOLogin,
    page: require("../../component/sso/ssoLoginIndex.html"),
  },
  reg: {
    url: "#/reg",
    initRoute: kotemplates.registerReg,
    page: require("../../component/reg/regIndex.html"),
  },
  userInfo: {
    url: "#/userInfo",
    initRoute: kotemplates.registerUserInfo,
    page: require("../../component/userInfo/userInfoIndex.html"),
  },
  "wechat-bind": {
    url: "#/wechat-bind",
    initRoute: kotemplates.registerBindQR,
    page: require("../../component/login/wechatBind/WechatBindIndex.html"),
  },
  "wx-bind": {
    url: "#/wx-bind",
    initRoute: kotemplates.registerBindQR,
    page: require("../../component/login/wechatBind/WxBindIndex.html"),
  },
  "weixiao-bind": {
    url: "#/weixiao-bind",
    initRoute: kotemplates.registerBindQR,
    page: require("../../component/login/wechatBind/WeixiaoBindIndex.html"),
  },
  "dd-bind": {
    url: "#/dd-bind",
    initRoute: kotemplates.registerBindQR,
    page: require("../../component/login/wechatBind/DingTalkIndex.html"),
  },
  "feishu-bind": {
    url: "#/feishu-bind",
    initRoute: kotemplates.registerBindQR,
    page: require("../../component/login/wechatBind/FeishuIndex.html"),
  },
  qrcode: {
    url: "#/qrcode",
    initRoute: kotemplates.registerQRCode,
    page: require("../../component/qrCode/index.html"),
  },
  logout: {
    url: "#/logout",
    initRoute: kotemplates.registerLogout,
    page: require("../../component/logout/logoutIndex.html"),
  },
  resetPassword: {
    url: "#/resetPassword",
    callback: function (req) {
      if (req.query && req.query.badPassword) {
        $("body").data("badPassword", {
          token: req.query.token,
        });
      }
      if (req.query && req.query.type) {
        $("body").data("type", {
          type: req.query.type,
        });
      }
    },
    initRoute: kotemplates.registerRestPassword,
    page: require("../../component/resetPassword/resetPasswordIndex.html"),
  },
  updatePassword: {
    url: "#/updatePassword",
    initRoute: kotemplates.registerRestPassword,
    page: require("../../component/resetPassword/updatePassword.html"),
  },
  setPhone: {
    url: "#/setPhone",
    initRoute: kotemplates.registerRestPassword,
    page: require("../../component/resetPassword/setPhone.html"),
  },
  mailRest: {
    url: "#/mailRest",
    page: require("../../component/resetPassword/mailRest.html"),
  },
};



//////////////////
// WEBPACK FOOTER
// ./src/routes/config/index.js
// module id = 212
// module chunks = 0